var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vcb-signin',{on:{"redirect-signup":function($event){return _vm.goto('/signup')}}})}
var staticRenderFns = []

export { render, staticRenderFns }